export function localeUpdate() {
    return {
        ordinal: num => {
            const b = num % 10;
            const output = (~~(num % 100 / 10) === 1) ? 'th' :
                           (b === 1) ? 'st' :
                           (b === 2) ? 'nd' :
                           (b === 3) ? 'rd' : 'th';
            return num + output;
        },
        relativeTime: {
            future: 'in %s',
            past: '%s',
            s: 'a few secs',
            ss: '%d secs',
            m: '%d min',
            mm: '%d mins',
            h: '%d hr',
            hh: '%d hrs',
            d: '%d d',
            dd: '%d d',
            M: '%d m',
            MM: '%d m',
            y: 'a year',
            yy: '%d years'
        }
    };
}
